import { ReactComponent as addNotes } from '../../../../icons/add_notes.svg';
import { ReactComponent as errorIcon } from '../../../../icons/error.svg';
import React, { useContext, useState } from "react";
import './addRegistrationCardModal.scss';
import Modal from "../../../../components/modalWindow/modal";
import ButtonField from '../../../../components/buttonField/buttonField';
import { iconPosition } from '../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../components/buttonField/types/buttonFieldProps';
import { stylizationVerticalAlign } from '../../../../components/shared/stylization';
import { KRType } from './types/cardType';
import { AddRegistrationCardModalProps } from './types/addRegistrationCardModalProps';
import { AdditionalIcon } from '../../../../components/shared/additionalIcon/additionalIcon';
import { CreateRegistrationCard } from '../../../../services/registrationCardService/registrationCardService';
import { RegistrationCardProperties } from '../../../../services/registrationCardService/types/registrationCardServiceProps';
import { apiContext } from '../../../../contexts/apiContext';
import { notifyError, notifySuccess } from '../../../../components/snackbar/snackbar';
import PermissionsContext from '../../../../contexts/permissionsContext';
import { ObjectCategories } from '../../administrationView/AdministrationPermissionExtendedView/types/administrationsPermissionExtendedViewProps';

const AddRegistrationCardModal = (props: AddRegistrationCardModalProps) => {
    const api = useContext(apiContext);
    const { extendedUserPermissions } = useContext(PermissionsContext);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const getBtnProps = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>, permissionDisable: boolean): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                style: {
                    width: '146px',
                    height: '146px'
                },
                className: "cardItem body-txt-XL",
                disabled: permissionDisable ? permissionDisable : buttonDisabled
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: addNotes,
            iconPosition: iconPosition.Start,
        };
    }

    const footerIconCss = {
        fill: '#C42914',
        width: '16px',
        height: '16px',
        marginRight: '8px'
    }

    const getFooterNode = () => {
        return <>
            {AdditionalIcon(errorIcon, footerIconCss)}{getFooterText("KR 2020", "od 18.02.2021")}; {getFooterText("KR 2007", "do 17.02.2021")}
        </>
    }

    const getFooterText = (krType: string, startDate: string) => {
        return <><span className="boldFooter">{krType}</span> - Obowiązuje {startDate}</>
    }

    const createCard = (properties: RegistrationCardProperties) => {
        setButtonDisabled(true);
        CreateRegistrationCard(properties, api.apiUrl, api.apiVersion).then((data: any) => {
            notifySuccess({ message: "Dodano kartę rejestracyjną" });
            setButtonDisabled(false);
        }).catch((error: any) => {
            notifyError({ message: "Dodanie karty rejestracyjnej zakończone niepowodzeniem" });
            setButtonDisabled(false);
        });
    }

    const addKR = (krType: KRType) => {
        var properties: RegistrationCardProperties;
        switch (krType) {
            case KRType.KRO2007: {
                properties = {
                    Type: "osuwisko",
                    cardPattern: "2007"
                }
                createCard(properties);
                break;
            }
            case KRType.KRO2020: {
                properties = {
                    Type: "osuwisko",
                    cardPattern: "2020"
                }
                createCard(properties);
                break;
            }
            case KRType.KRTZ2007: {
                properties = {
                    Type: "tz",
                    cardPattern: "2007"
                }
                createCard(properties);
                break;
            }
            case KRType.KRTZ2020: {
                properties = {
                    Type: "tz",
                    cardPattern: "2020"
                }
                createCard(properties);
                break;
            }
        }
    }

    const getKRPermissions = (objectCategory: ObjectCategories) => {
        if (extendedUserPermissions.userObjectCategories?.length! > 0) 
            return extendedUserPermissions.userObjectCategories?.includes(objectCategory);
        else return true;
    }

    return (<Modal
        title={"Dodaj kartę"}
        titleIcon={addNotes}
        width={'640px'}
        height={'280px'}
        footerNode={getFooterNode()}
        onClose={props.onClose}>
        <div className="cardBtns">
            <ButtonField {...getBtnProps("KRO 2020", () => { addKR(KRType.KRO2020) }, !getKRPermissions(ObjectCategories.Landslide)!)}></ButtonField>
            <ButtonField {...getBtnProps("KRTZ 2020", () => { addKR(KRType.KRTZ2020) }, !getKRPermissions(ObjectCategories.EndangeredArea)!)}></ButtonField>
            <ButtonField {...getBtnProps("KRO 2007", () => { addKR(KRType.KRO2007) }, !getKRPermissions(ObjectCategories.Landslide)!)}></ButtonField>
            <ButtonField {...getBtnProps("KRTZ 2007", () => { addKR(KRType.KRTZ2007) }, !getKRPermissions(ObjectCategories.EndangeredArea)!)}></ButtonField>
        </div>
    </Modal>);
};

export default AddRegistrationCardModal;